var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cs-product-list-item",
      style: {
        backgroundColor: _vm.button.Color,
        color: _vm.getTextColor(_vm.button.Color),
      },
      on: {
        click: function ($event) {
          return _vm.add()
        },
      },
    },
    [
      _c("div", { staticClass: "item-info" }, [
        _c("div", { staticClass: "product-id" }, [
          _vm._v(_vm._s(_vm.button.Text)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }